import Contract from "slotworks/utils/contracts/contract";
import AGSExitFreespins from "ags/states/ags-exit-freespins";
import reelsetModifier from "utils/reelset-modifier";
import smartUiFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import { ChangeMatrixFreespinsCommand } from "commands/change-matrix-freespins-command";
import lightningBorderAnimationUtil from "utils/lightning-border-animation-util";
import Layers from "slotworks/graphics/layers/layers";
import { LLCustomLayers } from "../../../lib/luck-and-luxury/src/names";

export default class CGExitFreespins extends AGSExitFreespins {

    public onEnter() {
        super.onEnter();
        if (Layers.Custom.get(LLCustomLayers.LOGOS).hasScene("default")) {
            Layers.Custom.get(LLCustomLayers.LOGOS).setScene("default").execute();
        }
    }

    protected resetMatrix() {
        smartUiFlags.set(SmartUIFlag.BONUS, false);
        reelsetModifier.restartInitialReelset("freespins");
        ChangeMatrixFreespinsCommand();
        lightningBorderAnimationUtil.useBaseLightningBorder();
        return Contract.empty();
    }
}
